import styled from "styled-components";

export const StyledTextBox = styled.div`
  display: flex;
  flex-direction: column;

  & .label {
    white-space: break-spaces;
  }
  & .text {
    overflow-wrap: anywhere;
  }
`;

export const StyledTextBoxGrid = styled.div<{ $numCol: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$numCol}, 1fr);
  gap: 20px;
  width: 100%;
`;
